export default ({ text }) => ({
    valueListTextMenu: {
        ...text.text_md,
    },
});
